import { Plugins } from '@leverege/plugin';
const RelationshipUrlMutatorFactory = Plugins.createFactory('RelationshipUrlMutator', {
  strategy: Plugins.ALL,
  pluginKey: 'mutate'
});
export default RelationshipUrlMutatorFactory;